import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

const options = [
  'Show some love to Material-UI',
  'Show all notification content',
  'Hide sensitive notification content',
  'Hide all notification content',
];

class LocationSelector extends React.Component {
  button = null;

  state = {
    anchorEl: null,
    selectedIndex: 0,
  };

  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    const { onMenuItemClick, service } = this.props
    const { locations } = service
    const selectedLocation = locations[index]

    onMenuItemClick([selectedLocation.longitude, selectedLocation.latitude],
                    selectedLocation.zoom,
                    selectedLocation.maxBounds,
                    selectedLocation.name)

    this.setState({ selectedIndex: index, anchorEl: null });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, service, defaultValue } = this.props;
    const { anchorEl } = this.state;
    const { locations } = service

    return (
      <div className={classes.root}>
        <List component="nav">
          <ListItem
            button
            aria-haspopup="true"
            aria-controls="lock-menu"
            aria-label="When device is locked"
            onClick={this.handleClickListItem}
          >
            <ListItemText
              primary={locations[this.state.selectedIndex] && locations[this.state.selectedIndex].name}
            />
          </ListItem>
        </List>
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {locations.map((location, index) => (
            <MenuItem
              key={location.name}
              selected={index === this.state.selectedIndex}
              onClick={event => this.handleMenuItemClick(event, index)}
            >
              {location.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

LocationSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  service: PropTypes.object.isRequired,
  onMenuItemClick: PropTypes.func
};

LocationSelector.defaultProps = {
  onMenuItemClick: () => 'location selected'
}

export default withStyles(styles)(LocationSelector);



// WEBPACK FOOTER //
// ./src/components/LocationSelector.js